export default __webpack_public_path__ + "static/media/56t.16d2131b.jpg";